import React from "react";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import { useFormikContext } from "formik";

const BlockMenuCTA = ({ header, copy, cta, focus }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <div className="pt3 bb hairline-1">
      <div className="f4 ph3 pb3 fw5">{header}</div>
      <div className="f6 ph3 pb3 lh-copy">{copy}</div>
      <div className="ph3 pb3">
        <Button
          theme="slim"
          onClick={() => {
            focus.forEach(({ key, value }) => setFieldValue(key, value));
          }}
          classes={{
            contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
          }}
          copy={cta}
        />
      </div>
    </div>
  );
};

export default BlockMenuCTA;
